import { EntityClient, AuthClient, FileClient, PortalClient, AnalyticsClient, ServiceOfferClient, IConfig, AdminClient, BNCClient, PTwoClient } from './TaxAnalyticsClient';
import Axios from 'axios';
import useDebounce from './useDebounce';
import { PrettyBytes } from './Numbers';
import * as JSONDecycle from './JSONDecycle';
export { getInitialAvatar } from './Avatar/AvatarGenerator';
export { natsort } from './natsort';


const instance = Axios.create({
    transformResponse: [],
    //transformRequest: [(data, headers) => {
    //    if (data) {
    //        const parsed = JSON.parse(data);
    //        const refData = JSONDecycle.createReferencePointers(parsed);
    //        return JSON.stringify(refData);
    //    }
    //    return data;
    //}, ...(Axios.defaults.transformRequest as any)]
});
const config = new IConfig();
const entityClient = new EntityClient(config, process.env.PUBLIC_URL, instance);
const authClient = new AuthClient(config, process.env.PUBLIC_URL, instance);
const fileClient = new FileClient(config, process.env.PUBLIC_URL, instance);
const portalClient = new PortalClient(config, process.env.PUBLIC_URL, instance);
const analyticsClient = new AnalyticsClient(config, process.env.PUBLIC_URL, instance);
const serviceOffer = new ServiceOfferClient(config, process.env.PUBLIC_URL, instance);
const adminClient = new AdminClient(config, process.env.PUBLIC_URL, instance);
const bncClient = new BNCClient(config, process.env.PUBLIC_URL, instance);
const ptwoClient = new PTwoClient(config, process.env.PUBLIC_URL, instance);

const customFileClient = (progressCallback: (progressEvent: any) => void) => new FileClient(config, process.env.PUBLIC_URL, Axios.create({
    transformResponse: [],
    transformRequest: [(data, headers) => {
        if (data) {
            const parsed = JSON.parse(data);
            const refData = JSONDecycle.createReferencePointers(parsed);
            return JSON.stringify(refData);
        }
        return data;
    }, ...(Axios.defaults.transformRequest as any)],
    onDownloadProgress: progressCallback
}));

const customAnalyticsClient = (progressCallback: (progressEvent: any) => void) => new AnalyticsClient(config, process.env.PUBLIC_URL, Axios.create({
    transformResponse: [],
    transformRequest: [(data, headers) => {
        if (data) {
            const parsed = JSON.parse(data);
            const refData = JSONDecycle.createReferencePointers(parsed);
            return JSON.stringify(refData);
        }
        return data;
    }, ...(Axios.defaults.transformRequest as any)],
    onDownloadProgress: progressCallback
}));

const ApiClient = { entityClient, authClient, fileClient, portalClient, analyticsClient, serviceOffer, customFileClient, adminClient, customAnalyticsClient, bncClient, ptwoClient };
function truncateString(str: string | undefined, num: number) {
    if (!str)
        return ""
    if (str.length <= num) {
        return str
    }
    return str.slice(0, num) + '...'
}
export { ApiClient, useDebounce, PrettyBytes, truncateString };
